export function getInitials(name?: string | null, email?: string | null, initial?: string) {
  if (initial?.trim()) {
    return initial.trim().slice(0, 2).toUpperCase();
  }

  if (name?.trim()) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return parts[0][0].toUpperCase();
  }

  if (email?.trim()) {
    return email.trim()[0].toUpperCase();
  }

  return 'U';
}

export default getInitials;
